import BpkSelectableChip from '@skyscanner-internal/backpack-web/bpk-component-chip';
import AirportsIcon from '@skyscanner-internal/backpack-web/bpk-component-icon/sm/airports';
import BusIcon from '@skyscanner-internal/backpack-web/bpk-component-icon/sm/bus';
import NewWindowIcon from '@skyscanner-internal/backpack-web/bpk-component-icon/sm/new-window';
import SelfServiceIcon from '@skyscanner-internal/backpack-web/bpk-component-icon/sm/self-service';
import BpkMobileScrollContainer from '@skyscanner-internal/backpack-web/bpk-component-mobile-scroll-container';
import classNames from 'classnames';

import { useMBDContext } from '../common/MBD/useMBDContext';

import type { Chip } from '@skyscanner-internal/landing-pages-shared-types/types-shared/ThemeCardProps';

import STYLES from './SelectedChips.module.scss';

type SelectedChipsProps = {
  activeChipIndex: number;
  setActiveChipIndex: (index: number) => void;
  chips: Chip[];
  cardType: 'Stack' | 'Rail';
};
const Icons: { [key: string]: JSX.Element } = {
  bus: <BusIcon />,
  airports: <AirportsIcon />,
  'self-service': <SelfServiceIcon />,
  'new-window': <NewWindowIcon />,
};

const SelectedChips = ({
  activeChipIndex,
  cardType,
  chips,
  setActiveChipIndex,
}: SelectedChipsProps) => {
  const { buildMBDParam, rawComponentName } = useMBDContext();
  if (!chips?.length) {
    return null;
  }

  return (
    <div
      className={classNames(STYLES.SelectableChip, {
        [STYLES['SelectableChip--stack']]: cardType === 'Stack',
        [STYLES['SelectableChip--rail']]: cardType === 'Rail',
      })}
    >
      <BpkMobileScrollContainer>
        {chips.map((chip, index) => {
          if (chip.name) {
            return (
              <div className={STYLES.SelectableChip__item} key={chip.name}>
                <BpkSelectableChip
                  key={chip.name}
                  accessibilityLabel={chip.name}
                  selected={index === activeChipIndex}
                  onClick={() => setActiveChipIndex(index)}
                  leadingAccessoryView={
                    chip?.icon && Icons[chip.icon] ? Icons[chip.icon] : null
                  }
                  data-tracking-element-id={`${rawComponentName}_chips_${index}`}
                  data-tracking-common-params={buildMBDParam(
                    `${rawComponentName}_chip`,
                    {
                      tab_name: chip.name,
                    },
                  )}
                >
                  {chip.name}
                </BpkSelectableChip>
              </div>
            );
          }
          return null;
        })}
      </BpkMobileScrollContainer>
    </div>
  );
};

export default SelectedChips;
